import React from "react"
import { useStore } from "../../../stores/RootStoreContext"
import { ClientOrderList } from "../../client/order/ClientOrderList"
import { ManagerOrderList } from "../../manager/order/ManagerOrderList"

export const OrderList = () => {
  const { userStore } = useStore()

  if (userStore.isClient) {
    return <ClientOrderList />
  } else if (userStore.isManager || userStore.isAdmin) {
    return <ManagerOrderList />
  } else {
    return <></>
  }
}
